import { UsersList } from "../../../users/UsersList"


export const SchoolUsersListContainer = () => {
    return (
        <UsersList isSchool={true} />
    );
};